import history from '../../history';


export const handleSignInFailure = (error) => {
    //alert("Not able to sign-in with those credentials!");
    window.location.reload();
    return null;
};

export const handleSignInSuccess = (userInfo) => {
    history.push('/');
    return userInfo;
}

